export const TYPE_GAP_OPTIONS = [
  { value: 'relative', name: 'Relative', disabled: false },
  { value: 'absolute', name: 'Absolute', disabled: false },
  { value: 'trend', name: 'Trend vs 2015', disabled: false },
];
